import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { useFormDialogs } from "@/components/FormDialogs";
import { getRegistrationUrl, EVENT_ENDED } from "@/config";

export const FinalCTA = () => {
  const { t, lang } = useLanguage();
  const { openPartner } = useFormDialogs();
  const c = t.finalCta;

  return (
    <section className="relative py-28 md:py-36 bg-[#010E3A] border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 grain opacity-[0.03] pointer-events-none" />
      <div className="container-page relative text-center">
        <Reveal>
          <h2 className="font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-4xl mx-auto">
            {c.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            {!EVENT_ENDED && (
            <a
              href={getRegistrationUrl(lang)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-ticket-btn"
              className="group inline-flex items-center justify-center gap-2 bg-[#CEA26B] hover:bg-[#BE965D] text-[#01154F] px-8 py-4 font-semibold tracking-wide transition-colors"
            >
              {c.ctaTicket}
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
            )}
            <button
              onClick={() => openPartner()}
              data-testid="final-partner-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/25 hover:bg-white/10 text-white px-8 py-4 font-semibold tracking-wide transition-colors"
            >
              {c.ctaPartner}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
